<div class="flex flex-col gap-4 max-w-xs">
  <input
    #fileInput
    type="file"
    accept="image/*"
    class="hidden"
    (change)="onFileSelected($event)"
  />

  <!-- Preview + Cancel Button -->
  <div *ngIf="previewUrl; else uploadButton" class="relative inline-block">
    <div
      class="w-full h-16 overflow-hidden rounded border border-gray-600 "
    >
      <img
        [src]="previewUrl"
        alt="File preview"
        class="w-full h-full object-contain"
      />
    </div>

    <button
      type="button"
      mat-icon-button
      (click)="cancelUpload()"
      style="position: absolute"
      class="top-1 right-1 bg-white p-1"
      aria-label="Cancel upload"
    >
      <mat-icon> close</mat-icon>
    </button>
  </div>

  <!-- Upload Button -->
  <ng-template #uploadButton>
    <button
      type="button"
      mat-stroked-button
      class="bg-blue-600 text-white rounded px-4 py-2 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      (click)="triggerFileInput(fileInput)"
    >
      Upload File
    </button>
  </ng-template>

  <!-- Progress Bar -->
  <div
    *ngIf="uploadProgress !== null"
    class="w-full bg-gray-200 rounded h-2 overflow-hidden"
  >
    <div
      class="bg-primary h-2 transition-all duration-300"
      [style.width.%]="uploadProgress"
    ></div>
  </div>

  <!-- Upload Result -->
  <div *ngIf="uploadResult" class="text-green-700">
    <p>Upload complete!</p>
  </div>

  <!-- Error Message -->
  <div *ngIf="error" class="text-red-600">
    <p>Error: {{ error.message || error }}</p>
  </div>
</div>
